import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IHeaderAngularComp } from 'ag-grid-angular';


@Component({
    standalone: true,
    selector: 'ag-header-renderer',
    templateUrl: './ag-header-renderer.component.html',
    styleUrls: ['./ag-header-renderer.component.scss'],
    imports: [CommonModule,MatTooltipModule]
  })
export class AgHeaderRendererComponent implements IHeaderAngularComp {
    params: any;
    
    agInit(params: any): void {
        this.params = params;
    }

    refresh(params: any): boolean {
        return false;
    }
}